export default {
  initSearchPlaceHolder ($searchInput) {
    // const $searchInput = $('.convention-header-search.convention-header-search-input')
    console.log($searchInput)
    if ($(window).width() < 1024) {
      $searchInput.attr('placeholder', $searchInput.attr('data-placeholder-mobile'))
    } else {
      $searchInput.attr('placeholder', $searchInput.attr('data-placeholder'))
    }

    $(window).on('resize', () => {
      if ($(window).width() < 1024) {
        $searchInput.attr('placeholder', $searchInput.attr('data-placeholder-mobile'))
      } else {
        $searchInput.attr('placeholder', $searchInput.attr('data-placeholder'))
      }
    })
  },

  setCookie (name, value, nbHours = 1) {
    const date = new Date()
    date.setTime(date.getTime() + (nbHours * 60 * 60 * 1000))
    const expires = 'expires=' + date.toString()
    document.cookie = name + '=' + value + ';' + expires + ';path=/'
  },

  getCookie (name) {
    const cookies = document.cookie
    const cookiesArray = cookies.split('; ')
    for (let i = 0; i < cookiesArray.length; i++) {
      const cookie = cookiesArray[i].split('=')
      if (cookie[0] === name) {
        return cookie[1]
      }
    }
    return null
  },

  getValueFromUrl (variableName, names) {
    const url = new URL(this.decodeURI(window.location.href))
    const variable = url.searchParams.get(variableName)

    if (variable) {
      return variable.split(',').map(slug => {
        return {
          value: slug,
          label: names[slug]
        }
      })
    }

    return []
  },

  decodeURI (url) {
    return url.replace(/&amp;/g, '&')
  },

  selectedTaxo: {
    add ($sample, $list, option, taxoName) {
      const $tempSelectedType = $sample.clone()

      $tempSelectedType.removeClass('hidden')
      $tempSelectedType.addClass(option.value)
      $tempSelectedType.find('.selected-taxo-label').html(option.label)
      $tempSelectedType.attr('data-slug', option.value)
      $tempSelectedType.attr('data-taxo-name', taxoName)

      $list.prepend($tempSelectedType)
    },

    remove ($select, slug) {
      $select.find(`.selectbox-option[data-value="${slug}"]`).removeClass('selected')
    },

    removeAll (selects) {
      for (let i = 0; i < selects.length; i++) {
        selects[i].find('.selectbox-option.selected').removeClass('selected')
      }
    }
  }
}
